import React, { useState } from "react";
import "../styles/intake.css";


export default function ClinicProfileForm({ formData, setFormData }) {
  const [isEditing, setIsEditing] = useState(true);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const clinicId = formData.clinic_id || "default_clinic_id";
  
    const formDataToSend = new FormData();
    formDataToSend.append("file", file);
    formDataToSend.append("clinic_id", clinicId);
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/upload-business-license?clinic_id=${clinicId}`, {
        method: "POST",
        body: formDataToSend,
      });
  
      const result = await response.json();
  
      if (response.ok) {
        alert("✅ Business license uploaded successfully!");
        setFormData((prev) => ({
          ...prev,
          business_license: [...(prev.business_license || []), result.url],// store array
        }));
      } else {
        alert("❌ Upload failed: " + result.detail);
      }
    } catch (error) {
      alert("❌ Upload error: " + error.message);
    }
  };
  
  
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  

  const handleDeleteLicense = async (url) => {
    const confirmed = window.confirm("Are you sure you want to delete this document?");
    if (!confirmed) return;
  
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/delete-business-license`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          clinic_id: formData.clinic_id,
          file_url: url,
        }),
      });
  
      if (!res.ok) {
        const error = await res.json();
        console.error("Delete failed:", error.detail);
        alert("Delete failed: " + error.detail);
      } else {
        // ✅ Remove from UI
        setFormData((prev) => ({
          ...prev,
          business_license: prev.business_license.filter((f) => f !== url),
        }));
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Error deleting file.");
    }
  };
  
  
  
  

  const handleSave = async () => {
    const clinicPayload = {
      clinic_id: formData.clinic_id || null,
      name: formData.name,
      website: formData.website,
      address: formData.address,
      admin: formData.admin,
      phone: formData.phone,
      email: formData.email,
      instagram: formData.instagram,
      facebook: formData.facebook,
      twitter: formData.twitter,
      google_map: formData.google_map,
      business_license: Array.isArray(formData.business_license)
        ? formData.business_license
        : [formData.business_license], // ensure it's an array

    };
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/save-clinic-profile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(clinicPayload),
      });
  
      const result = await response.json();
  
      if (response.ok) {
        alert("✅ Clinic profile saved successfully!");
        setFormData((prev) => ({
          ...prev,
          clinic_id: result.clinic_id,  // update clinic_id if created
        }));
        setIsEditing(false);
      } else {
        alert("❌ Save failed: " + result.detail);
      }
    } catch (error) {
      alert("❌ Save error: " + error.message);
    }
  };
  
  const handleEdit = () => {
    setIsEditing(true);
  };
  

  return (
    <div className="form-wrapper">
      {/* Top Header */}
      <div className="form-header">
      <img src="/logo.png" alt="Olumis AI Logo" className="form-logo" />
        <h1 className="form-title">Clinic Information Form</h1>
        <div className="form-header-buttons" />
      </div>

      {/* Section Header with Buttons */}
      <div className="form-section-header">
        <h2>1. <span className="section-title">Clinic Profile</span></h2>
        <div className="form-buttons">
          {isEditing ? (
            <button className="blue-button" onClick={handleSave}>Save</button>
          ) : (
            <button className="blue-button" onClick={handleEdit}>Edit</button>
          )}
        </div>
      </div>

      <div className="separator" />

      {/* Form Grid */}
      <div className="form-grid">
        {[
          ["Clinic Name", "clinic_name", "text", true],
          ["Clinic Website", "website", "url", true],
          ["Address", "address", "text", true],
          ["Contact Person", "admin", "text", true],
          ["Phone", "phone", "tel", true],
          ["Email", "email", "email", true],
          ["Instagram", "instagram", "text", false],
          ["Facebook", "facebook", "text", false],
          ["X / Twitter", "twitter", "text", false],
          ["Google Map", "google_map", "text", true],
        ].map(([label, name, type, required]) => (
          <div key={name} className="form-field">
            <label>
              {label}
              {required && <span className="required">*</span>}
            </label>
            <input
              type={type}
              name={name}
              value={formData[name] || ""}
              onChange={handleChange}
              required={required}
            />
          </div>
        ))}

        {/* File Upload */}
        <div className="form-field full-width">
        <label>Business License (Upload)</label>
        <input
          type="file"
          name="business_license"
          onChange={handleFileUpload}
          multiple
        />

        {/* ✅ Show uploaded business licenses as a list of links */}
        {Array.isArray(formData.business_license) && formData.business_license.length > 0 && (
          <ul style={{ marginTop: "8px", fontSize: "14px", color: "#004aad" }}>
            {formData.business_license.map((url, index) => (
              <li key={index}>
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {url.split("/").pop()}
                </a>
                <button
                onClick={() => handleDeleteLicense(url)}
                style={{
                  color: "red",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
                title="Delete this file"
              >
                ✕
              </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      </div>
    </div>
  );
}

